//import axios from "axios";
import ApiService from "@/core/services/api.service";


// action types
export const OBTENER_ROLES = "obtenerRoles";
export const OBTENER_ROLES_INSTITUCIONALES = "obtenerRolesInstitucionales";
export const OBTENER_ROLES_ADMINISTRADOR = "obtenerRolesAdministrador";
export const OBTENER_ROL = "obtenerRol";
export const ACTUALIZAR_ROL = "actualizarRol";
//export const REGISTRAR_REGION = "registrarRegion";
// mutation types
export const SET_ROLES = "setRoles";
export const SET_ROL = "setRol";

const state = {
    roles: [],
    rol:[],
}

const getters = {
    obtenerRoles(state) {
      return state.roles;
    },
}

const actions = {
    /**
     * Obtener Regiones (todos o por estado (activo, incativo, etc))
     * @param {} context 
     * @param {*} estadoId 
     * @returns 
     */
    async [OBTENER_ROLES](context, estadoId) {

        let endpoint = 'api/RolUsuario'
        if(estadoId){
            endpoint = `api/RolUsuario/Estado/${estadoId}`
        }
      

        return new Promise(resolve => {
            ApiService.query(`apiconsume/obtener?endpoint=${endpoint}`, '')
                .then(({ data }) => {
                    context.commit(SET_ROLES, data.data);
                    //console.log(data)
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error)

                    //context.commit(SET_ERROR, response.data.errors);
                });
        });      
    },


    /**
     * Obtener los roles de administradores
     * 6  Super admin
     * @param {} context 
     * @param {*} estadoId 
     * @returns 
     */
     async [OBTENER_ROLES_ADMINISTRADOR](context) {

        let endpoint = 'api/RolUsuario/Administrador'
       /* if(estadoId){
            endpoint = `api/RolUsuario/Estado/${estadoId}`
        }*/
      

        return new Promise(resolve => {
            ApiService.query(`apiconsume/obtener?endpoint=${endpoint}`, '')
                .then(({ data }) => {
                    context.commit(SET_ROLES, data.data);
                    //console.log(data)
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error)

                    //context.commit(SET_ERROR, response.data.errors);
                });
        });      
    },



    /**
     * Obtener los roles que utilizan las instituciones para registrar sus usuaios
     * 2 Aprobador
     * 3 Revisor
     * @param {} context 
     * @param {*} estadoId 
     * @returns 
     */
     async [OBTENER_ROLES_INSTITUCIONALES](context) {

        let endpoint = 'api/RolUsuario/Institucionales'
       /* if(estadoId){
            endpoint = `api/RolUsuario/Estado/${estadoId}`
        }*/
      

        return new Promise(resolve => {
            ApiService.query(`apiconsume/obtener?endpoint=${endpoint}`, '')
                .then(({ data }) => {
                    context.commit(SET_ROLES, data.data);
                    //console.log(data)
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error)

                    //context.commit(SET_ERROR, response.data.errors);
                });
        });      
    },

    async [OBTENER_ROL](context, id) {

        return new Promise(resolve => {
            ApiService.get(`apiconsume/edit/${id}?endpoint=api/RolUsuario/`, '')
                .then(({ data }) => {
                    context.commit(SET_ROL, data.data);
                    //console.log(data)
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error)

                    //context.commit(SET_ERROR, response.data.errors);
                });
        });      
    },

    async [ACTUALIZAR_ROL](context, datosRol){
        let id = datosRol.id;
        return new Promise(resolve => {
            ApiService.post(`apiconsume/update/${id}?endpoint=api/RolUsuario/`, datosRol)
                .then(({ data }) => {
                    context.commit(SET_ROL, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });   
    },

}


const mutations = {
    [SET_ROLES](state, data) {
        state.roles = data;
    },

    [SET_ROL](state, data) {
        state.rol = data;
    }
}


export default {
    state,
    getters,
    actions,
    mutations
}